import { Box, TablePagination, TextField } from '@mui/material';

interface SearchAndPaginationProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  totalCount: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const SearchAndPagination = ({
  searchQuery,
  onSearchChange,
  totalCount,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}: SearchAndPaginationProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 2,
      }}
    >
      <TextField
        label="Rechercher"
        className="inputElement"
        variant="outlined"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{ marginRight: 2, minWidth: 300 }}
      />
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        labelRowsPerPage="Lignes par page"
        labelDisplayedRows={({ from, to }) => `de ${from} à ${to}`}
      />
    </Box>
  );
};

